// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__8PNhq","overallTable":"style__overallTable__+N4W7"};